var request, db;
const dbName = "e2g";
const tableName = "files";
const readonly = "readonly";
const readwrite = "readwrite";

let loadDB = () => {
  return new Promise((resolve) => {
    if (!window.indexedDB) {
      console.log("Your Browser does not support IndexedDB");
    } else {
      request = window.indexedDB.open(dbName, 1);
      request.onerror = function (event) {
        console.log("Error opening DB", event);
        resolve();
      };
      request.onupgradeneeded = function (event) {
        db = event.target.result;
        db.createObjectStore("layouts", {
          keyPath: "id",
          autoIncrement: true,
        });
        db.createObjectStore("files", {
          keyPath: "id",
          autoIncrement: true,
        });
        resolve();
      };
      request.onsuccess = function (event) {
        db = event.target.result;
        resolve();
      };
    }
  });
};

let getAll = async () => {
  await loadDB();
  return new Promise((resolve) => {
    var request = db
      .transaction([tableName], readonly)
      .objectStore(tableName)
      .getAll();
    request.onsuccess = function (event) {
      resolve(request.result);
    };
  });
};

let getById = async (id) => {
  await loadDB();
  return new Promise((resolve) => {
    var request = db
      .transaction([tableName], readonly)
      .objectStore(tableName)
      .get(id);
    request.onsuccess = function (event) {
      resolve(request.result);
    };
  });
};

let insert = async (layoutId, fileName, fileContent) => {
  await loadDB();

  var transaction = db.transaction([tableName], readwrite);
  var objectStore = transaction.objectStore(tableName);
  objectStore.add({
    layoutId: layoutId,
    fileName: fileName,
    fileContent: fileContent,
  });

  transaction.oncomplete = function (event) {
    //console.log("Success :)");
  };

  transaction.onerror = function (event) {
    console.log("Error");
  };
};

let destroy = async (id) => {
  localStorage.removeItem("lastCLickedTabForFile" + id);
  await loadDB();
  db.transaction([tableName], readwrite).objectStore(tableName).delete(id);
};

export { loadDB, insert, destroy, getAll, getById };
